import React from 'react'

const MtnPlay = () => {
  return (
    <div>MtnPlay</div>
  )
}

export default MtnPlay